import FeatureContainsMetadata from './FeatureContainsMetadata.js';
import FeatureClass from '../system-metadata/FeatureClass.js';
/**
 * @memberof geodata
 * @param {feature-references.FeatureRecord}
 * @return {Promise<FeatureClass[]>}
 */
function availableFeatureClasses(feature) {
    const geoJSON = feature.toGeoJSON();
    const available = Promise.all([
        FeatureClass.all(),
        FeatureContainsMetadata.forFeature(geoJSON),
    ])
        .then(([featureClasses, metadata]) => {
        const featureClassesWithFeatures = metadata.reduce((memo, meta) => {
            memo[meta.featureClass] = meta;
            return memo;
        }, {});
        return [...featureClasses]
            .filter((featureClass) => {
            const featureClassMetadata = featureClassesWithFeatures[featureClass.id];
            return featureClassMetadata && featureClassMetadata.isValidQuery();
        })
            .sort((a, b) => a.order - b.order);
    });
    return available;
}
export default availableFeatureClasses;
